export default __webpack_public_path__ + "static/cert-icon-17-e53eac9d2cdd141860eb25fec1fbcb3d.png";